import { html } from 'lit';
import componentStyles from './container.css.lit.ts';
import { OutlineElement } from '../../base/outline-element/outline-element.ts';

export default class Container extends OutlineElement {
  static styles = [super.styles, componentStyles];

  render() {
    return html` <slot></slot> `;
  }
}

customElements.define('hf-container', Container);
